var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',[_c('h4',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),(_vm.subTitle)?_c('h6',{staticClass:"sub-title"},[_vm._v("\n        "+_vm._s(_vm.subTitle)+"\n      ")]):_vm._e()])]),_vm._v(" "),_c('router-view',{on:{"sub-title":_vm.setSubTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }